import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./branding/Logo";
import configs from "../configs.json";
import MobileNav from "./MobileNav";

const MobileHeader: React.FC = () => {
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);

  return (
    <header className="flex md:hidden items-center justify-between px-4 py-3 w-full border-b border-b-glitch-box relative">
      {/* Toggle mobile popup */}
      {isPopupOpen && <MobileNav />}

      {/* Hamburder button for small device */}
      <button
        className="flex items-center md:hidden"
        onClick={() => setIsPopupOpen(!isPopupOpen)}
      >
        <span
          className={`material-icons-outlined ${isPopupOpen ? "text-glitch-orange" : "text-white"
            }`}
        >
          menu
        </span>
      </button>

      {/* Site branding */}
      <div>
        <Logo />
      </div>

      {/* Header navigation */}
      <div>
        <Link to={"/profile"} className="flex items-center">
          <img
            src="../../faviconnew.png"
            alt="Abu Raihan"
            className="w-8 h-8 rounded border-none"
          />
          <span className="font-medium hidden sm:block ml-2 text-white">
            {configs.userName}
          </span>
        </Link>
      </div>
    </header>
  );
};

export default MobileHeader;
